(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-purchase-options"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(){
    var box=document.querySelector('[data-pg-mobile-buy]');
    if(!box||box.dataset.ready)return;
    box.dataset.ready='1';
    var form=box.closest('form'), info=box.closest('.pg-product__info');
    var qty=form.querySelector('[name="quantity"]');
    if(!qty)return;
    var qtyWrap=qty.closest('[data-qty]').parentElement;
    var mq=window.matchMedia('(max-width:899px)');
    var review=new URLSearchParams(location.search).has('pg_mobile_review');
    var bundle=null, signatures='';
    function money(cents){
      return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:box.dataset.currency||'USD'}).format(cents/100);
    }
    function setQty(value){
      qty.value=value;
      qty.dispatchEvent(new Event('change',{bubbles:true}));
    }
    box.addEventListener('change',function(e){
      if(e.target.name==='pg_supply')setQty(e.target.value);
    });
    qty.addEventListener('change',function(){
      box.querySelectorAll('[name="pg_supply"]').forEach(function(r){r.checked=Number(r.value)===Number(qty.value)});
    });
    function sync(){
      var active=mq.matches||review;
      box.hidden=!active;
      info.classList.toggle('pg-mobile-options',active);
      info.closest('.pg-product__layout').classList.toggle('pg-mobile-review',review);
      qtyWrap.hidden=active;
      var widget=document.querySelector('.bndlr-volume[data-bndlr-variant-id="'+box.dataset.variant+'"]');
      if(widget&&!bundle){
        bundle=widget;
      }
      if(bundle)bundle.hidden=active;
      if(!bundle)return;
      var tiers=Array.from(bundle.querySelectorAll('.bndlr-volume-discount')).map(function(t){
        var p=t.querySelector('.bndlr-new-price');
        return {qty:Number(t.dataset.quantity),unit:p?Number(p.dataset.currentprice):NaN,unitText:p?p.textContent.trim():'',saving:t.querySelector('.bndlr-volume-saving-text')?.textContent||''};
      }).filter(function(t){return (t.qty===2||t.qty===3)&&Number.isFinite(t.unit)});
      var sig=JSON.stringify(tiers);
      if(sig===signatures)return;
      signatures=sig;
      var cards=box.querySelector('[data-pg-buy-cards]');
      cards.querySelectorAll('[data-tier]').forEach(function(el){el.remove()});
      tiers.forEach(function(t){
        var label=document.createElement('label');label.className='pg-buy-card';label.dataset.tier=t.qty;
        var radio=document.createElement('input');radio.type='radio';radio.name='pg_supply';radio.value=t.qty;radio.checked=Number(qty.value)===t.qty;
        var badge=document.createElement('span');badge.className='pg-buy-badge';badge.textContent=t.qty===3?box.dataset.best:box.dataset.bundle;
        var copy=document.createElement('span');copy.className='pg-buy-copy';
        var title=document.createElement('strong');title.textContent=box.dataset.buy+' '+t.qty;
        var per=document.createElement('small');per.textContent=t.unitText+' '+box.dataset.perBottle;
        var saving=document.createElement('span');saving.className='pg-buy-saving';saving.textContent=t.saving;
        copy.append(title,per,saving);
        var total=document.createElement('strong');total.className='pg-buy-total';total.textContent=money(Math.round(t.unit*t.qty));
        var was=document.createElement('del');was.textContent=money(Number(box.dataset.unitPrice)*t.qty);total.append(was);
        label.append(radio,copy,total,badge);cards.append(label);
      });
    }
    var queued=false;
    var observer=new MutationObserver(function(){
      if(queued)return;
      queued=true;
      requestAnimationFrame(function(){queued=false;sync()});
    });
    observer.observe(form.closest('.pg-product__layout').parentElement,{childList:true,subtree:true});
    mq.addEventListener('change',sync);
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
